import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { compact } from 'lodash';

import { PricingPlanFragment } from '../../../../graphql.schema';
import PricingPanel from '../../PricingPanel';
import { ContentBlock } from '../../ContentBlock/ContentBlock';

import * as styles from './StrapiPricingPlan.module.scss';

export const StrapiPricingPlanComponent = ({ mainHeading, mainDescription, deliveryMethods }: PricingPlanFragment) => {

  const DeliveryMethodsList: React.FC<Props> = ({ deliveryMethods }) => {
    return (
      <div className={styles.columns}>
        {deliveryMethods.map((item) => {
          const { deliveryMethod, link, showFeatures, showPrice } = item;
          if (!deliveryMethod || !deliveryMethod.id) {
            return null; // Skip rendering if deliveryMethod is missing or invalid
          }
          return (
            <div key={deliveryMethod?.id} className={classnames(styles.card, { [styles.highlighted]: deliveryMethod?.isRecommended })}>
              <PricingPanel
                pricingPlanHeading={deliveryMethod.pricingPlanHeading}
                pricingPlanDescription={deliveryMethod.pricingPlanDescription}
                features={deliveryMethod.features}
                bannerText={deliveryMethod.bannerText}
                link={deliveryMethod.link}
                learnMoreLink={link}
                isRecommended={deliveryMethod.isRecommended}
                showPrice={showPrice}
                price={deliveryMethod.price}
                showFeatures={showFeatures}
              />
              <div id={`modal-container-${deliveryMethod.id}`} />
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div className={styles.root}>
      {mainHeading || mainDescription ? (
        <div className="container">
          <div className={styles.heading}>
            <ContentBlock title={mainHeading ?? ''} content={mainDescription ?? ''} />
          </div>
        </div>
      ) : null}
      <div className={styles.columnsWrapper}>
        <div>
          <DeliveryMethodsList deliveryMethods={deliveryMethods} />
        </div>
      </div>
    </div>
  );
};
